<template>
  <div
    class="fixed inset-0 z-50 flex min-h-screen w-screen items-center justify-center bg-gradient-to-br from-kekkle-purple via-kekkle-purple-dark to-kekkle-dark"
  >
    <div class="mx-auto max-w-xl px-6">
      <div class="flex flex-col items-center gap-6 text-center">
        <!-- Error Icon with Animation -->
        <div class="animate-bounce-slow">
          <div
            class="flex h-24 w-24 items-center justify-center rounded-full bg-white/10 backdrop-blur-sm"
          >
            <span class="text-5xl">📡❌</span>
          </div>
        </div>

        <!-- Error Message -->
        <div class="space-y-3">
          <h1 class="text-3xl font-bold text-white">
            {{ title }}
          </h1>
          <p class="mx-auto max-w-sm text-lg font-medium text-white/90">
            {{ message }}
          </p>
        </div>

        <!-- Action Buttons -->
        <div class="mt-4 flex flex-col gap-3 sm:flex-row">
          <default-button class="min-w-[180px]" @click="handleAction">
            {{ actionLabel }}
          </default-button>
          <default-button
            color="red"
            class="min-w-[180px] hover:bg-white/20"
            @click="handleSecondaryAction"
          >
            {{ secondaryActionLabel }}
          </default-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import DefaultButton from "@/components/Buttons/DefaultButton.vue";

defineProps({
  title: {
    type: String,
    required: true,
  },
  message: {
    type: String,
    required: true,
  },
  actionLabel: {
    type: String,
    default: "Try Again",
  },
  secondaryActionLabel: {
    type: String,
    default: "Logout",
  },
});

const emit = defineEmits(["action", "secondaryAction"]);

function handleAction() {
  emit("action");
}

function handleSecondaryAction() {
  emit("secondaryAction");
}
</script>

<style scoped>
@keyframes bounce-slow {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.animate-bounce-slow {
  animation: bounce-slow 3s ease-in-out infinite;
}
</style>
